export default __webpack_public_path__ + "static/media/location.1219497d.svg";